import { useAuth } from "@agentech/auth-client";
import { config } from "../../config";

export function ImpersonationBanner() {
  const { user, refreshSession } = useAuth();

  if (!user?.isImpersonating) return null;

  const handleEnd = async () => {
    try {
      await fetch(
        `${config.apiBaseUrl}/v1/admin/impersonate?sessionId=${user.impersonationSessionId}`,
        { method: "DELETE", credentials: "include" },
      );
    } catch {
      // Best effort
    }
    // Refresh session to pick up the real user identity
    await refreshSession();
  };

  return (
    <div className="impersonation-banner">
      <span>
        Impersonating <strong>{user.email}</strong>
        {user.impersonatedBy && <> (by {user.impersonatedBy})</>}
      </span>
      <button type="button" onClick={handleEnd} className="btn btn-sm">
        End Impersonation
      </button>
    </div>
  );
}
